import axios from "axios";

// Instância separada para o portal do representante
// NÃO usa interceptors do useAuth (que redirecionariam para /login do painel)
const partnerApi = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
});

// Interceptor simples: só adiciona o token do parceiro
partnerApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("partnerToken");
  if (token) config.headers["Authorization"] = `Bearer ${token}`;
  return config;
});

export default partnerApi;
